import React, { useEffect, useMemo, useState } from 'react';

export default function RotatingModelCarousel({ models = [], intervalMs = 2500 }) {
  const list = useMemo(() => (models && models.length ? models : [
    'Perplexity', 'ChatGPT', 'Google AI Overviews', 'Microsoft Copilot', 'Grok', 'Gemini'
  ]), [models]);

  const [idx, setIdx] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const t = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setIdx((i) => (i + 1) % list.length);
        setTimeout(() => {
          setIsAnimating(false);
        }, 100);
      }, 300);
    }, intervalMs);
    return () => clearInterval(t);
  }, [list.length, intervalMs]);

  return (
    <div className="rotator-container">
      <span className={`rotator-text ${isAnimating ? 'animating' : ''}`}>
        {list[idx]}
      </span>
    </div>
  );
}


